import type { ThemeColors } from '../../../../tokens/colors/types';
import { border } from './border';
import { divider } from './divider';
import { blue, green, neutral, orange, pale, purple, red } from './palette';
import { deals, retail } from './product';
import { critical, info, positive, shout, warning } from './semantic';
import { typography } from './typography';

const primary = {
  '10': '#E6F3FF',
  '20': '#E6F3FF',
  '30': '#5CB4FF',
  '50': '#005DAD',
  '70': '#003F75',
  '80': '#002C52',
  '90': '#000D29',
};

const secondary = {
  '20': '#FFFAE5',
  '30': '#FFEDA3',
  '50': '#FFD633',
  '70': '#DBAF00',
  '90': '#8F7200',
};

const baseColors: ThemeColors = {
  blue,
  green,
  red,
  orange,
  primary,
  secondary,
  purple,
  neutral,
  pale,
  info,
  warning,
  critical,
  positive,
  deals,
  retail,
  shout,
  border,
  divider,
  typography,
};

export default baseColors;
